<div *ngIf="errorMessage" class="page-error">
    <img src="assets/icons/Icon-Error.svg" alt="Error circle" id="error-icon">
    <span [innerHTML]="errorMessage"></span>
    <img src="assets/icons/Icon-Navigation-Exit-Close-Black.svg" *ngIf="dismissable" (click)="onDismiss.emit()" id="dismiss-button">
</div>